import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import './CustomDatePicker.css'


const CustomDateRangePicker = ({ onDateRangeChange,
    startDefaultDate,
    endDefaultDate,
    style,
    maxDisableDates,
    minDisableDates,
    inline,
    sizeType
}) => {
    // Set default start and end dates if not provided, otherwise use the props
    const defaultStartDate = startDefaultDate || "";    
    const defaultEndDate = endDefaultDate || "";
    // State for date range
    const [dateRange, setDateRange] = useState([defaultStartDate, defaultEndDate]);
    const [startDate, endDate] = dateRange;


    useEffect(() => {
        if (startDefaultDate && endDefaultDate) {
            setDateRange([startDefaultDate, endDefaultDate]);
        }
    }, [startDefaultDate, endDefaultDate]);



    const handleChange = (update) => {
        const [newStartDate, newEndDate] = update;
        setDateRange([newStartDate, newEndDate]);
        if (onDateRangeChange) {
            onDateRangeChange([newStartDate, newEndDate]);
        }
    };


    return (
        <>
            <div className="selectDate ">
                <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={handleChange}
                    isClearable={true}
                    dateFormat="dd/MM/YYYY"
                    placeholderText="Select a date range"
                    // Inline styles for DatePicker
                    style={{
                        padding: "18px !importent",
                    }}
                    maxDate={maxDisableDates}
                    minDate={minDisableDates}
                    inline={inline || false}
                    wrapperClassName={`custom-datepicker-${sizeType ||"normal"} `}

                />

            </div>
        </>
    );

};



export default CustomDateRangePicker;
